import React, { useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata, AddCountriesData, CountriesEditData, DeleteData } from '../reduxactions/adminrsactions/AdCountryActions';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';
import { GFNButton } from '../ui';

export const AdminCountry = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const data = useSelector((state: RootState) => state.adcounrtylist.data);
  const adddata = useSelector((state: RootState) => state.adcounrtylist.adddata);
  const editdata = useSelector((state: RootState) => state.adcounrtylist.editdata);
  const deletedata = useSelector((state: RootState) => state.adcounrtylist.deletedata);
  const toast = useRef(adddata);
  const toast1 = useRef(editdata);
  const toast2 = useRef(deletedata);
  const dispatch = useDispatch()

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);

  const [countriesadd, setAddCountries] = useState(false);
  const [CountryName, setCountryName] = useState<any>(null);
  const [countriesedit, setCountriesEdit] = useState(false);

  const AddCountriesclose = async () => {
    setAddCountries(false);
    setDeleteConfirmation(false);


  }
  //To add Countries dispatching data to ts
  const AddCountries = async () => {
    await dispatch(AddCountriesData(CountryName) as any);
    toast.current.show({ severity: 'success', summary: 'Added Successfully', detail: adddata, life: 3000 })
    setAddCountries(false);
    fetchDataAsync();
    setCountryName('')

  };
  const [editData, setEditData] = useState({
    CountryName: '',
    id: '',
  });

  const Editdata = (rowData: any) => {
    setEditData({
      CountryName: rowData.CountryName,
      id: rowData.CountryID,
    });
    setCountriesEdit(true);
  }

  //To dispatch edit data fieldofficer.ts
  const EditAdminCountries = async () => {
    const { id, CountryName } = editData;
    await dispatch(CountriesEditData(CountryName, parseInt(id, 10)) as any);
    toast1.current.show({ severity: 'success', summary: 'Edited Successfully', detail: editdata, life: 3000 })
    setCountriesEdit(false);
    fetchDataAsync();

  };

  const [deleteConfirmation, setDeleteConfirmation] = useState(false);


  const [delData, setDeleteData] = useState({
    id: '',
  });

  const Delete = (rowData: any) => {
    setDeleteData({
      id: rowData.CountryID,
    });
    setDeleteConfirmation(true);
  };
  const confirmDelete = async () => {
    const { id } = delData;
    try {
      await dispatch(DeleteData(id) as any);
      toast2.current.show({ severity: 'success', summary: 'Deleted Successfully', detail: deletedata, life: 3000 })
      setDeleteConfirmation(false);
    } catch (error) {
      console.error('Error deleting data:', error);
    }

    fetchDataAsync();

  };
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateName = (value: string) => {
    if (!/^[A-Za-z]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, CountryName: 'Name must contain only letters' }));
    } else {
      setErrors((prev) => ({ ...prev, CountryName: '' }));
    }
    setCountryName(value);
  };
  const isFormValid = CountryName && Object.values(errors).every((error) => !error);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/admin-Country.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div>
      <div className="admin-layout-container">
        <div className="row">
          <div className="main-content">
            <div className="content-wrapper">
              {/* <section className="content-header">
                <div className="container-fluid">
                  <div className="grid mb-2">
                    <div className="col-9">
                      <h1>Countries</h1>
                    </div>
                    <div className="col-3">
                      <a title="help" onClick={(e) => openWindow(e, IUrl)} style={{ color: "blue", fontSize: 15, cursor: "pointer" }}
                      >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </section> */}
              <section className="app-page-header">
                <div>
                  <h1 className="app-page-title">Countries</h1>
                </div>
                <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                  Help for this Page
                  <i className="pi pi-question-circle"></i>
                </a>
              </section>
              {/* <section className="content"> */}
              <div className="grid">
                <div className="col-12">
                  <div className="card card-primary">
                    {/* <Card title=""> */}
                    <Panel header="">

                      <div className="card flex flex-wrap justify-content-end">
                        {/* <Button label="Add Countries" severity="info" data-testid="add-country-btn" onClick={() => setAddCountries(true)} /> */}
                        <GFNButton label="Add Countries" buttonType="primary" data-testid="add-country-btn" onClick={() => setAddCountries(true)} />
                      </div>

                      <div className="card flex flex-wrap justify-content-end my-2">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search ml-2" />

                          <InputText
                            className="app-search-input"
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Global Search"
                          />
                        </span>
                      </div>
                      <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="CountryName" sortable header="Country"></Column>
                        <Column header="Operation" body={(rowData, { rowIndex }) => (
                          <>
                            {/* <Button rounded outlined data-testid={`edit-btn-${rowIndex}`} className='mr-3' tooltip="Edit" icon="pi pi-pencil" onClick={() => Editdata(rowData)} style={{ backgroundColor: 'white', color: 'seagreen' }} /> */}
                            <GFNButton icon="pi pi-pencil" buttonType="success" size="sm" tooltip="Edit" className='mr-3' testId={`edit-btn${rowIndex}`} onClick={() => Editdata(rowData)} />
                            <GFNButton icon="pi pi-trash" buttonType="danger" size="sm" tooltip="Delete" testId={`delete-btn${rowIndex}`} onClick={() => Delete(rowData)} />
                            {/* <Button icon="pi pi-trash" rounded outlined data-testid={`delete-btn-${rowIndex}`} tooltip="Delete" onClick={() => Delete(rowData)} className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red' }} /> */}
                          </>
                        )} />
                      </DataTable>
                    </Panel>
                    {/* </Card> */}
                  </div>
                  {/* </div> */}
                </div>
                <Toast ref={toast} />
                <Toast ref={toast1} />
                <Toast ref={toast2} />
                {/* </section> */}
              </div>
            </div>
          </div>
        </div>
        <Dialog header="Add Countries" breakpoints={{ '960px': '75vw', '641px': '100vw' }} data-testid="add-dialog" visible={countriesadd} style={{ width: '30vw' }} onHide={() => setAddCountries(false)} >
          <div className="border d-flex align-items-center justify-content-center">
            <div className="card">
              <div className="grid pt-3">
                <div className="col-3">
                  <label htmlFor="name" className="col-sm-2 control-label">Country Name:</label>
                </div>
                <div className="col-12 md:col-9 lg:col-8" >
                  <InputText id="name" data-testid="country-input" value={CountryName} className="w-full mb-5" name="countryname" placeholder='Enter Country' onChange={(e) => validateName(e.target.value)} />
                  {errors.CountryName && <small className="p-error">{errors.CountryName}</small>}
                </div>
              </div>
              {/* <Button label="Close" onClick={AddCountriesclose} data-testid="close-country-btn" severity="secondary" />
              <Button label="Add" disabled={!isFormValid} data-testid="add-dialog-country-btn" onClick={AddCountries} style={{ float: 'right' }} /> */}
              <div className="flex justify-content-end gap-2 mt-4">
                <GFNButton label="Close" onClick={AddCountriesclose} data-testid="close-country-btn" buttonType="secondary" />
                <GFNButton label="Add" disabled={!isFormValid} data-testid="add-dialog-country-btn" onClick={AddCountries} buttonType="primary" />
              </div>
            </div>
          </div>
        </Dialog>
        <Dialog header="Edit Country" breakpoints={{ '960px': '75vw', '641px': '100vw' }} data-testid="edit-dialog" visible={countriesedit} style={{ width: '30vw' }} onHide={() => setCountriesEdit(false)} >
          <div className="border d-flex align-items-center justify-content-center">
            <div className="card">
              <div className='grid'>
                <div className="grid pt-3">
                  <div className="col-8">
                    <label htmlFor="name" className="col-sm-2 control-label">Country Name</label>
                  </div>
                  <div className="col-7" >
                    <span className="p-float-label">
                      <InputText id="name" style={{ width: '25vw' }} data-testid="edit-country-input" name="cname" onChange={(e) => setEditData({ ...editData, CountryName: e.target.value })} value={editData.CountryName} />
                    </span>
                  </div>
                </div>
              </div>
              {/* <Button label="Update" data-testid="edit-country-btn" onClick={EditAdminCountries} /> */}
              <div className="flex justify-content-end gap-2 mt-4">
                <GFNButton label="Close" onClick={() => setCountriesEdit(false)} data-testid="close-edit-country-btn" buttonType="secondary" />
                <GFNButton label="Update" data-testid="edit-country-btn" onClick={EditAdminCountries} buttonType="success" />

              </div>
            </div>
          </div>
        </Dialog>
        {/*DELETE DIALOG */}
        <Dialog header="Confirm Delete" style={{ width: '30vw' }} data-testid="delete-dialog" visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
          <div>Are you sure you want to delete this item?</div>
          {/* <Button label="Yes" icon="pi pi-check" className='mr-3 p-button-raised' data-testid="confirm-delete-btn" onClick={confirmDelete} />
          <Button label="No" icon="pi pi-times" onClick={AddCountriesclose} data-testid="cancel-delete-btn" className="mr-3 p-button-secondary" /> */}
          <div className="flex justify-content-end gap-2 mt-4">
            <GFNButton label="No" icon="pi pi-times" onClick={AddCountriesclose} data-testid="cancel-delete-btn" buttonType="secondary" />
            <GFNButton label="Yes" icon="pi pi-check" data-testid="confirm-delete-btn" onClick={confirmDelete} buttonType="danger" />
          </div>
        </Dialog>
        <Toast ref={toast} >
          <Message severity="success" content={adddata} />
        </Toast>
      </div>
    </div>
  )
}
export default AdminCountry

